import { Instagram, Facebook } from "lucide-react";
import { useBooking } from "../context/BookingContext";

export const Footer = () => {
  const { openBooking } = useBooking();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-[#111111] text-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Big logo */}
          <div className="md:col-span-6">
            <h2 className="font-serif font-light text-6xl md:text-8xl uppercase tracking-[0.12em] leading-none">
              Picaso
            </h2>
            <p className="mt-6 text-[#FDFBF7]/60 font-light text-sm max-w-sm leading-[1.6]">
              Bridal hair, makeup, and luxury scalp wellness. Two decades of artistry in
              Vaughan, Ontario.
            </p>
            <button
              data-testid="footer-book-button"
              onClick={() => openBooking()}
              className="mt-8 underline-grow text-xs uppercase tracking-[0.2em] text-champagne"
            >
              Secure a Consultation
            </button>
          </div>

          {/* Links */}
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#FDFBF7]/40 mb-6">Explore</p>
            <ul className="space-y-4 font-light text-sm">
              <li><a href="#artistry" className="hover:text-champagne transition-colors">Artistry</a></li>
              <li><a href="#scalp-lounge" className="hover:text-champagne transition-colors">The Scalp Lounge</a></li>
              <li><a href="#lookbook" className="hover:text-champagne transition-colors">Bridal Lookbook</a></li>
              <li><a href="#studio" className="hover:text-champagne transition-colors">The Studio</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#FDFBF7]/40 mb-6">Atelier</p>
            <ul className="space-y-4 font-light text-sm text-[#FDFBF7]/80">
              <li>4220 Steeles Avenue West<br />Woodbridge, ON, Canada</li>
              <li>(905) 851-9106</li>
              <li>atelier@picasostudios.ca</li>
            </ul>
            <div className="flex gap-5 mt-8">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="text-[#FDFBF7]/70 hover:text-champagne transition-colors">
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="text-[#FDFBF7]/70 hover:text-champagne transition-colors">
                <Facebook size={18} strokeWidth={1.5} />
              </a>
            </div>
            <p className="mt-4 text-xs text-[#FDFBF7]/50">@picasostudios</p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#FDFBF7]/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#FDFBF7]/40">
          <p>© {year} Picaso Studios. All rights reserved.</p>
          <p className="uppercase tracking-[0.2em]">Crafted in Vaughan</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
